// Fallback Accessibility Statement content for Norfolk Registrars ceremonies.
// Source of truth is the BookingLab app config key `accessibilityStatementPage.pageContent`
// (SUP-2540). This default renders the page before/if that config is absent.
//
// Uses the shared council-agnostic default. If this council supplies its own audited
// statement, set the app config key — or replace this re-export with the client's text.

// Imported via the '@bookinglab/ui/accessibility' subpath rather than the '@bookinglab/ui'
// barrel: the constant is plain text, and the barrel would pull the Angular component
// library into every app (solihull-ceremonies deliberately does not use it).

export { GENERIC_ACCESSIBILITY_STATEMENT as ACCESSIBILITY_STATEMENT_FALLBACK } from '@bookinglab/ui/accessibility';
